var variantMetafieldFilter = {

  elements: {},
  currentSelection: [],
  cookieName: 'variant_metafield_filter_selection',

  init: function() {
    if(typeof Cookies == 'undefined') {
      return;
    }

    if(typeof productVariantCard == 'undefined') {
      return;
    }

    if(!this.getElements()) {
      this.clearSavedCurrentSelection();

      return;
    }

    this.loadCurrentSelection();
    this.checkCheckboxesByCurrentSelection();
    this.enableDisableCheckboxes();
    this.updateFilterSelectors();
    this.setEvents();
  },

  getElements: function() {
    this.elements.wrappers = jQuery('.variant-metafield-filter');
    if(!this.elements.wrappers.length) {
      return false;
    }

    this.elements.checkboxes = jQuery('.variant-metafield-filter__checkbox');
    if(!this.elements.checkboxes.length) {
      return false;
    }

    return true;
  },

  clearSavedCurrentSelection: function() {
    Cookies.remove(this.cookieName);
  },

  loadCurrentSelection: function() {
    var currentSelectionJson = Cookies.get(this.cookieName);

    if(typeof currentSelectionJson == 'undefined') {
      return;
    }

    var currentSelection = JSON.parse(currentSelectionJson);

    if(currentSelection.collectionId != this.elements.wrappers.first().data('collection-id')) {
      this.clearSavedCurrentSelection();

      return;
    }

    this.currentSelection = currentSelection.selection;
  },

  checkCheckboxesByCurrentSelection: function() {
    for(var i=0; i<this.currentSelection.length; i=i+1) {
      var metafield = this.currentSelection[i].metafield;

      for(var i2=0; i2<this.currentSelection[i].values.length; i2=i2+1) {
        var value = this.currentSelection[i].values[i2];

        this.elements.wrappers.filter('[data-variant-metafield="' + metafield + '"]').find('.variant-metafield-filter__checkbox[value="' + value + '"]').prop('checked', true);
      }
    }
  },

  enableDisableCheckboxes: function() {
    var _self = this;

    this.elements.checkboxes.parent('.filter__checkbox--disabled').removeClass('filter__checkbox--disabled');

    var checkedCheckboxes = this.elements.checkboxes.filter(':checked');

    checkedCheckboxes.each(function() {
      var checkbox = jQuery(this);
      var wrapper = checkbox.parents('.variant-metafield-filter');

      if(!wrapper.length) {
        return true;
      }

      var siblingCheckboxes = wrapper.find('.variant-metafield-filter__checkbox').not(checkedCheckboxes);

      siblingCheckboxes.parent('.filter__checkbox').addClass('filter__checkbox--disabled');
    });
  },

  updateFilterSelectors: function() {
    for(var i=0; i<this.currentSelection.length; i=i+1) {
      var metafield = this.currentSelection[i].metafield.replace('_', '-');
      var selectorFirstPart = '[data-metafield-' + metafield + '="';

      // Remove all current selectors which contain selectorFirstPart.
      var i2 = 0;
      while(i2 < productVariantCard.filterSelectors.length) {
          if(productVariantCard.filterSelectors[i2].indexOf(selectorFirstPart) == -1) {
            i2 = i2 + 1;

            continue;
          }

          productVariantCard.filterSelectors.splice(i2, 1);
      }

      // Push new selectors.
      for(var i2=0; i2<this.currentSelection[i].values.length; i2=i2+1) {
        productVariantCard.filterSelectors.push(selectorFirstPart + this.currentSelection[i].values[i2] + '"]');
      }
    }
  },

  setEvents: function() {
    var _self = this;

    this.elements.checkboxes.on('change', function() {
      _self.enableDisableCheckboxes();
      _self.getCurrentSelection();
      _self.updateFilterSelectors();
      productVariantCard.filter();
      _self.saveCurrentSelection();
    });
  },

  getCurrentSelection: function() {
    var _self = this;

    for(var i=0; i<this.currentSelection.length; i=i+1) {
      this.currentSelection[i].values = [];
    }

    this.elements.checkboxes.filter(':checked').each(function() {
      var checkbox = jQuery(this);
      var wrapper = checkbox.parents('.variant-metafield-filter');

      if(!wrapper.length) {
        return true;
      }

      var metafield = wrapper.data('variant-metafield');

      if(typeof metafield == 'undefined') {
        return true;
      }

      for(var i=0; i<_self.currentSelection.length; i=i+1) {
        if(_self.currentSelection[i].metafield != metafield) {
          continue;
        }

        _self.currentSelection[i].values.push(checkbox.val());

        return true;
      }

      _self.currentSelection.push({
        metafield: metafield,
        values: [
          checkbox.val()
        ]
      });
    });
  },

  saveCurrentSelection: function() {
    Cookies.set(this.cookieName, JSON.stringify({
      collectionId: this.elements.wrappers.first().data('collection-id'),
      selection: this.currentSelection
    }));
  }

};

jQuery(document).ready(function() {
  variantMetafieldFilter.init();
});
